import { render, staticRenderFns } from "./extract.vue?vue&type=template&id=109e4d6c&scoped=true&"
import script from "./extract.vue?vue&type=script&lang=ts&"
export * from "./extract.vue?vue&type=script&lang=ts&"
import style0 from "./extract.vue?vue&type=style&index=0&id=109e4d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109e4d6c",
  null
  
)

export default component.exports